import { InputTag } from 'mixs/base/input_mixin';
// import TimeLag from 'utilities/timelag';
interface IItem {
  index: number,
  value: string,
  checked: boolean,
  label: string
}
class Wrap {
}
export class ComplexDeliveryAttachmentsForCircle extends InputTag {
  items: Array<IItem> = [];
  testBar: boolean;
  // updateLag: TimeLag;
  labels: Array<string> = [
    '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'
  ]
  public init() {
    super.init();
    // this.updateLag = new TimeLag((params) => { this.onChangeTextDo(params) }, 500);
    this.watch();
    this.initItems()
    this.listenMount([this.onMountTag])
  }
  public onMountTag(){
    this.updateJSON()
  }
  public initItems(){
    const value = this.opts.value
    if(!value){
      this.testBar = false
      this.setInitItems()
    }else{
      const jsonValue = JSON.parse(value)
      const fileNames = jsonValue['other']
      this.testBar = jsonValue['test_bar'] ? true : false
      if(fileNames){
        this.setItemsByFilename(fileNames)
      }else{
        this.setInitItems()
      }
    }
  }
  public setItemsByFilename(fileNames){
    let items = []
    for(let i = 0; i < fileNames.length; i++){
      items.push(this.initialItem(i, fileNames[i], true))
    }
    items.push(this.initialItem(items.length))
    this.items = items
  }
  public setInitItems(){
    const jsonString = `[${this.initialJsonString(0)}]`
    this.items = JSON.parse(jsonString)
  }
  public initialJsonString(index: number){
    return JSON.stringify(this.initialItem(index))
  }
  public initialItem(index: number, value: string = '', checked: boolean = false){
    let label = this.labels[index]
    if(!label){ label = (index + 1).toString() }
    label = '書類' + label
    return {
      label: label,
      value: value,
      checked: checked,
    }
  }
  public onChangeTestBar(e){
    if(e.target.checked){
      this.testBar = true
    } else {
      this.testBar = false
    }
    this.updateJSON()
  }
  public onChangeCheckbox(e){
    if(e.target.checked){ this.focusTextField(e.target)}
    else{
      this.clearText(e.target)
      this.items = this.getNewItemsByText();
    }
    this.updateJSON()
  }
  public onChangeText(e){
    const length = this.items.length
    this.items = this.getNewItemsByText();
    this.updateJSON()
    if(this.items.length > length){
      setTimeout(() => { this.focusNextInput() }, 1)
    }
  }
  public focusNextInput(){
    const textfields = this.querySelectorAll(`input[type="text"]`)
    const textfield = textfields[textfields.length - 1] as HTMLInputElement
    textfield.focus()
  }
  public getNewItemsByText(){
    const wraps = this.querySelectorAll('.wrap')
    let items = []
    for(let i = 0; i < wraps.length; i++){
      let item = this.initialItem(i)
      const wrap = wraps[i] as HTMLElement
      const textfield = wrap.querySelector('input[type="text"]') as HTMLInputElement
      const value = textfield.value
      if(value == '') { continue }
      item.value = value
      item.checked = value != '' ? true : false
      items.push(item)
    }
    items.push(this.initialItem(items.length))
    this.resetLabels(items)
    return items
 }
  public resetLabels(items){
    for(let i = 0; i < items.length; i++){
      let label = this.labels[i]
      if(!label){ label = (i + 1).toString() }
      items[i].label = label
    }
    return items
  }
  public clearText(checkbox){
    const textfields = this.querySelectorAll(`.wrap input[type="text"]`)
    const checkboxies = this.querySelectorAll(`.wrap input[type="checkbox"]`)
    for(let i=0; i<checkboxies.length; i++){
      if(checkboxies[i] == checkbox){
        const textfield = textfields[i] as HTMLInputElement
        textfield.value = ''
        break
      }
    }
  }
  public focusTextField(checkbox){
    const textfield = checkbox.parentElement.parentElement.querySelector('input[type="text"]') as HTMLInputElement
    textfield.focus()
  }
  public updateJSON(){
    let json = this.objectArray(this.items)
    let value = JSON.stringify(json)
    this.dispatch({ value: value })
  }
  public objectArray(items){
    let object = {
      other: [],
      test_bar: this.testBar
    }
    for(let i = 0; i < items.length; i++){
      if(items[i].value != ''){
        object.other.push(items[i].value)
      }
    }
    return object
  }
}

riot.mixin('inputs.complex.delivery-attachments-for-circle', ComplexDeliveryAttachmentsForCircle as riot.TagMixin)
